const titles = {
    action: "Action",
    addSuccessfully: "Added Successfully",
    updateSuccessfully: "Updated Successfully",
    errorMessage: "Ops, something went wrong, try again",
    LoginerrorMessage: "Ops, something went wrong, please login Again",
    deletedSuccess: "deleted successfully",
    go_back: "Go Back",
    otpVerifiedMsg: "OTP Verified Successfully !",
    otpSentSuccessMsg: "OTP Sent Successfully !",
    registerSuccessMsg: "Register Successfully !",
    areYouSureWantToLogout: "Are you sure you want to logout?",
    successLogin: "You have been successfully logged in",
    update: "Update",
    save: "Save",
    item: "Item",
    profile: "Profile",
    dashboard: "Dashboard",
    changePassword: "Change Password",
    name: "Name",
    id: "Id",
    Please_enter_your_email: "Please enter your email",
    Please_enter_your_password: "Please enter your password",
    Forgot_password: "Forgot Password ?",
    Remember_me: "Remember me",
    Click_here: "Click here",
    Close: "Close",
    addnew: "Add New",
    client_id: "Client Id",
    client_secret: "Client Secret",
    tenant_id: "Tenant Id",
    services: "Services",
    enterToSearch: "Enter to search",
    email: "Email",
    phone: "Phone",
    openVolunteering: "Open Volunteering",
    myVolunteerBasket: "My Volunteer Basket",
    newHelpRequest: "New Help Request",
    userManagement: "User Management",
    volunteersManagement: "Volunteers Management",
    notificationLog: "Notification Log",
    aboutUs: "About Us",
    instructions: "Instructions",
    regulations: "Regulations",
    accessibilityStatement: "Accessibility Statement",
    fullName: "Full Name",
    type: "Type",
    registrationDate: "Registration Date",
    disability: "Disability",
    residentialAddress: "Residential Address",
    currentAddress: "Current Address",
    alerts: "Alerts",
    actions: "Actions",
    all: "All",
    volunteer: "Volunteer",
    user: "User",
    welcomeMessage: "Welcome to the purple vest app of the Israel Accessibility Association - to help people with disabilities in emergencies. Here you can help people with disabilities all over the country. Your help will significantly help the mission of the purple vest - to leave no one behind!",
    enterPhoneNumber: "Enter a phone number to receive a code via SMS",
    enterVerificationCode: "Enter the verification code",
    verifyCode: "Verify Code",
    getCode: "Get Code",
    registerAs: "Register as",
    clear: "Clear",
    editingMyProfile: "Edit my profile",
    exitFromSystem: "Exit from system",
    refresh: "Refresh",
    disableCategoryOption: "Disable below helping request category option known as your category request already under process or opened",
    chooseHelpType: "To get started, choose the type of help you're requesting",
    toNextStep: "To the next step",
    nextStep: "Next step",
    needRideTo: "I need a ride to",
    iAmFrom: "I am from",
    originAddressLonger: "Your origin address must be longer than 5 characters.",
    destinationAddressLonger: "Your Destination address must be longer than 5 characters.",
    wantToBeThereOn: "I want to be there on",
    selectFutureDate: "Please select a future date.",
    requestDetailsDescription: "Details and description of the request",
    descriptionLonger: "Your description must be longer than 5 characters.",
    untilRequestRelevant: "Until when the request is relevant",
    personalDetails: "Personal details",
    fullNameLonger: "Your full name must be longer than 5 characters.",
    phoneLonger: "Your phone must be longer than 5 characters.",
    residentialAddressLonger: "Your Residential Address must be longer than 5 characters",
    createNewHelpRequest: "Create new help request",
    enterValidPhoneNumber: "Enter a valid phone number",
    sentTo: "Sent to",
    date: "Date",
    time: "Time",
    channel: "Channel",
    content: "Content",
    usePrevious: "Use Previous",
    useCurrent: "Use Current",
    status: "Status",
    sendTo: "Send To",
    category: "Category",
    pendingApplicationUserRequestManagement: "Pending Application User Request Management",
    perPage: "Per Page",
    arrivalAddress: "Arrival Address",
    wayForCommunication: "Preferred way communication",
    whatsApp: "WhatsApp",
    welcomeDashboard: "Welcome Dashboard",
    iNeedARideTo: "I need a ride to",
    iWantToBeThereOn: "I want to be there on",
    at: "at",
    detailsAndDescriptionOfRequest: "Details and description of the request",
    toTheNextStep: "To the next step",
    goToNextStep: "Go to the next step",
    referenceDescription: "Reference description",
    comments: "Comments",
    relevantUntil: "Relevant until",
    sorryICantHelpThisTime: "Sorry, I can't help this time",
    imReadyAccept: "I'm ready to accept",
    appliedFilters: "Applied Filters",
    filtering: "Filtering",
    showVolunteers: "Show Volunteers",
    cancel: "Cancel",
    byCategory: "By Category",
    byTown: "By Town",
    accessibilityAndDisabilityInfo: "Information about accessibility and disability need",
    goBack: "Go Back",
    details: "Details",
    youCanContactMeAt: "You can contact me at",
    deletedSuccessMsg: "has been deleted successfully",
    yes: "Yes",
    no: "No",
    registerToHelp: "Register to help",
    joinUs: "Join us",
    role: "Role",
    switchAs: "Switch as",
    submit: "Submit",
    updateRoleMsg: "Role has been updated successfully",
    Please_enter_your_organization_name: "Organization Name",
    Summary_Description: "Summary Description",
    Please_enter_summary_description: "Please enter summary description",
    Please_enter_your_client_id: "Please enter your client Id",
    Please_enter_your_client_secret: "Please enter your client secret",
    Please_enter_your_tenant_id: "Please enter your tenant Id",
    Please_select_your_service: "Select Service",
    Add_Organization: "Add Organization",
    Submit: "Submit",
    Cancel: "Cancel",
    dataSaved: "Congratulations! We saved your data!",
    dataSavedTitle: "Data Saved",
    dataUpdated: "Congratulations! Your data has been updated!",
    dataUpdatedTitle: "Data Updated",
    organizationDeactivatedSuccess: "Organization deactivated successfully",
    organizationActivatedSuccess: "Organization activated successfully",
    organizationNameRequired: "Organization name must be a string",
    organizationNameMinLength: "Organization name must be at least 3 characters long",
    serviceRequired: "Please select a service",
    frequencyRequired: "Please select Frequency",
    clientIdRequired: "Client Id is required",
    clientIdValid: "Client Id must be a valid non-empty string",
    clientSecretValid: "Client secret must be a valid non-empty string",
    tenantIdRequired: "Tenant Id is required",
    tenantIdValid: "Tenant Id must be a valid non-empty string",
    deleteItem: "Are you sure you want to delete this item?",
    confirmDeletion: "Confirm Deletion",
    scheduledTasks: "Scheduled Tasks",
    AddscheduledTasks: "Add Scheduled Tasks",
    scheduled_type: "Scheduled Type",
    end_time: "End Time  (UTC)",
    description: "Description",
    settings: "Settings",
    EnterTaskName: "Task Name",
    TaskNameMinLength: "Task Name Must Be At Least 3 Characters Long",
    TaskNameIsRequired: "Task Name Field Is Required",
    EnterTaskdescription: "Task Description",
    Daily: "Daily",
    Hourly: "Hourly",
    SelectFrequency: "Select Frequency",
    EnterStartTime: "Start Time (UTC)",
    EnterEndTime: "End Time (UTC)",
    EnterDescription: "Please Add Description",
    EnterEmail: "Email",
    start_time: "Start Time (UTC)",
    startTimeRequired: "Start Time is required",
    descriptionRequired: "Description is required",
    TaskNameRequired: "Task Name is required",
    descriptionMinLength: "Description must be at least 10 characters",
    invalidTimeFormat: "Invalid time format. Please use HH:MM",
    endTimeRequired: "End Time is required",
    endTimeGreaterThanStartTime: "End Time must be greater than Start Time",
    emailRequired: "Email is required",
    invalidEmail: "Invalid email format",
    UpdatescheduledTasks: "Update Scheduled Tasks",
    ScheduledTaskDeletedTitle: "Scheduled Task Deleted",
    ScheduledTaskDeletedMessage: "Scheduled Task deleted successfully",
    TaskDeactivatedTitle: "Task deactivated",
    TaskDeactivatedMessage: "Task deactivated successfully",
    TaskActivatedTitle: "Task activated",
    TaskActivatedMessage: "Task activated successfully",
    SelectStatus: "Select Status",
    Active: "Active",
    Inactive: "Inactive",
    statusRequired: "Please select a status",
    Integrations: "Integrations",
    confirmDeletionIntegrations: "Delete Integration",
    deleteItemIntegrations: "Are you sure you want to delete this integration?",
    addIntegrations: "Add Integrations",
    integrationsDeletedSuccess: "Integration Deleted successfully",
    integrationsDeleted: "Integration Deleted",
    integrationsActivated: "Integration Activated",
    integrationsActivatedSuccess: "Integration activated successfully",
    integrationsDeactivated: "Integration Deactivated",
    integrationsDeactivatedSuccess: "Integration deactivated successfully",
    Users: "Users",
    confirmDeletionUsers: "Are you sure you want to delete this user?",
    deleteItemUsers: "User deleted successfully",
    usersDeleted: "User Deleted",
    usersDeletedSuccess: "User deleted successfully",
    usersActivated: "User Activated",
    usersActivatedSuccess: "User activated successfully",
    usersDeactivated: "User Deactivated",
    usersDeactivatedSuccess: "User deactivated successfully",
    confirmDeleteUsers: "Delete User",
    addUsers: "Add Users",
    endTimeGreater: "End time must be greater than start time",
    full_name: "Full Name",
    SelectRole: "Please select a role",
    Please_enter_your_full_name: "Please enter your full name",
    Please_enter_your_phone: "Please enter your phone number",
    Please_enter_your_Password: "Please enter your Password",
    phoneRequired: "PhoneNumber Field is Required",
    invalidPhone: "PhoneNumber is Invalid",
    passwordMinLength: "Password must be at least 8 characters long",
    passwordMismatch: "Passwords do not match",
    Confirm_your_Password: "Confirm your Password",
    Confirm_Password: "Confirm Password",
    UserdataSavedTitle: "User data saved",
    UserdataSaved: "Congratulations! We saved your User data!",
    confirmDeletionTask: "Delete Scheduled Task",
    deleteTask: "Are you sure you want to delete this Scheduled Task?",
    ConfirmSubmission: "Confirm Submission",
    ConfirmTaskName: "Task Name",
    ConfirmTaskDescription: "Task Description",
    ConfirmStartTime: "Start Time (UTC)",
    ConfirmEndTime: "End Time (UTC)",
    ConfirmEmail: "Email",
    ConfirmStatus: "Status",
    Confirm: "Confirm",
    TaskLogs: "Task Logs",
    AddTaskLogs: "Add Task Logs",
    task_id: "Task ID",
    task_name: "Task Name",
    recipient: "Recipient",
    TaskLogDeactivatedTitle: "Task Log Deactivated",
    TaskLogActivatedTitle: "Task Log Activated",
    TaskLogDeactivatedMessage: "The task log has been deactivated.",
    TaskLogActivatedMessage: "The task log has been activated.",
    TaskLogDeletedTitle: "Task Log Deleted",
    TaskLogDeletedMessage: "The task log has been deleted.",
    UpdateTaskLog: "Update Task Log",
    confirmDeletionTaskLog: "Are you sure you want to delete this task log",
    deleteTaskLog: "This action will permanently delete the task log.",
    Please_select_recipient: "Please select a recipient.",
    Please_select_Task: "Please select a task.",
    Task_Name: "Task Name",
    data: "Data",
    azure_end_point: "Azure End Point",
    azure_token: "Azure Token",
    azure_api_token: "Azure Api Token",
    azure_api_version: "Azure Api Version",
    grant_type: "Grant Type",
    username: "Username",
    password: "Password",
    keep_me_logged_in: "Keep me logged in",
    security_token: "Security Token",
    instance_url: "Instance url",
    google_client_id: "google client id",
    google_client_secret: "google client secret",
    google_redirect_uri: "google redirect uri",
    google_service_account_credentials_json: "google service account credentials json",
    TextCopySuccessfully: "Text copied successfully",
    TextCopied: "Text copied",
    microsoft_client_id: "Microsoft Client ID",
    microsoft_client_secret: "Microsoft Client Secret",
    microsoft_tenant_id: "Microsoft Tenant ID",
    ApiLogs: "Api Logs",
    url: "URL",
    method: "Method",
    request_payload: "Request Payload",
    response_payload: "Response Payload",
    status_code: "Status Code",
    service_id: "Service ID",
    user_id: "User ID",
    created_at: "Created At",
    Office365Users: "Office365 Users",
    integration_id: "Integration ID",
    select_integration: "Integration Select",
    microsoft_user_id: "Microsoft User ID",
    user_principal_name: "User Principal Name",
    preferred_language: "Preferred Language",
    office_location: "Office Location",
    job_title: "Job Title",
    surname: "Surname",
    given_name: "Given Name",
    Inbox: "Inbox",
    from: "From",
    to: "To",
    subject: "Subject",
    ShowMail: 'Show Mail',
    view_details: 'View Details',
    Insights: "Insights",
    AddInsights: "Add Insights",
    UpdateInsights: "Update Insights",
    product_service: "Product / Service",
    CRM: "CRM",
    Analytics: "Analytics",
    Net_Zero_Cloud: "Net Zero Cloud",
    Financial_Services_Cloud: "Financial Services Cloud",
    Communications_Cloud: "Communications Cloud",
    Education_Cloud: "Education Cloud",
    clickHere: "Click Here",
    error: "error",
    serviceNotSupported: "Service Not Supported",
    SalesforceUsers: "Salesforce Users",
    GsuitUsers: "G-suit Users",
    DomainAdminEmail: "Domain Admin Email",
    DomainName: "Domain Name",
    view_existing_credentials: "View Existing Credentials",
    billing_address: "Billing Address",
    crm_account_id: "Crm Account Id",
    shipping_address: "Shipping Address",
    SalesforceCrmUsers: "Salesforce Crm ",
    SalesforceEducationCloudUsers: "Salesforce Education Cloud ",
    SalesforceAnalyticsUsers: "Salesforce Analytics ",
    SalesforceNetZeroCloudUsers: "Salesforce Net Zero Cloud ",
    SalesforceFinancialServicesCloudUsers: "Salesforce Financial Services Cloud ",
    SalesforceCommunicationsCloudUsers: "Salesforce Communications Cloud ",
    communications_account_id: "Communications Account Id",
    site: "site",
    billing_state: "Billing State",
    owner_id: "Owner Id",
    owner_alias: "Owner Alias",
    analytics_report_id: "Analytics Report Id",
    folder_name: "Folder Name",
    developer_name: "Developer Name",
    format: "Format",
    financial_account_id: "Financial Account Id",
    financial_account_number: "Financial Account Number",
    source_system_identifier: "Source System Identifier",
    product_id: "Product Id",
    branch_unit_id: "Branch Unit Id",
    banker_id: "Banker Id",
    credit_limit: "Credit Limit",
    annual_emissions_inventory_id: "annual_emissions_inventory_id",
    total_scope_1_emissions: "total_scope_1_emissions",
    total_scope_2_emissions: "total_scope_2_emissions",
    total_scope_3_emissions: "total_scope_3_emissions",
    total_emissions: "total_emissions",
    final_emission_in_tco2e: "final_emission_in_tco2e",
    otp: "OTP",
    verify_otp: "Verify OTP",
    redirect_uri: "Redirect Uri",
    code: "Code",
    Zoho_CRM: "CRM",
    User: "User",
    Admin: "Admin",
    api_access_token: "API Access Token",
    notion_database_id: "Notion Database Id",
    notion_secret: "Notion Secret",
    AuditTrail: "Audit Trail",
    Model: "Model",
    contacts: "Contacts",
    deals_value: "Deals Value",
    title: "Title",
    priority: "Priority",
    company: "Company",
    integration: "Integration",
    crmContacts: "CRM Contacts",
    crmDeals: "CRM Deals",
    crmLeads: "CRM Leads",
    crmAccounts: "CRM Accounts",
    crmClientProjects: "CRM Client Projects",
    crmActivities: "CRM Activities",
    run: "Run",
    runNow: "Run Now",
    TaskRunSuccess: "Task executed successfully.",
    TaskRunMessage: "The scheduled task has been executed successfully.",
    TaskRunError: "Task execution failed.",
    TaskRunErrorMessage: "An error occurred while executing the task.",
    crm_user_id: "Crm User Id",
    mobile: "Mobile",
    dob: "DOB",
    city: "City",
    state: "State",
    country: "Country",
    ZohoCrmUsers: "Zoho Crm Users",
    SelectLimit: "Select Limit",
    deals: "Deals",
    monday: "Monday",
    owner: "Owner",
    value: "value",
    close_date: "Close Date",
    expected_close_date: "Expected Close Date",
    close_probability: "Close Probability",
    forecast_value: "Forecast Value",
    last_interation: "Last Interation",
    active_sequence: "Active Sequence",
    location: "Location",
    domain: "Domain",
    employee_count: "Employee Count",
    company_profile: "Company Profile",
    headquarter_location: "Headquarter Location",
    timeline: "Timeline",
    file: "file",
    stage: "stage",
    sync_status: "Sync Status",
    leads: "Leads",
    accounts: "Accounts",
    Activities: "Activities",
    ClientProject: "Client Project",
    expand: "Expand",
    people: "People",
    hide: "Hide",
    show: "Show",
    year: "Year",
    ZOHO: "Zoho",
    ZohoAccounts: "Zoho Accounts",
    ZohoDeals: "Zoho Deals",
    ZohoLeads: "Zoho Leads",
    ZohoPurchaseOrder: "Zoho Purchase Order",
    ZohoSalesOrder: "Zoho Sales Order",
    account_number: "Account Number",
    account_type: "Account Type",
    industry: "Industry",
    annual_revenue: "Annual Revenue",
    employees: "Employees",
    website: "Website",
    fax: "Fax",
    crm_deal_id: "CRM Deal ID",
    deal_name: "Deal Name",
    amount: "Amount",
    currency: "Currency",
    probability: "Probability",
    expected_revenue: "Expected Revenue",
    closing_date: "Closing Date",
    expected_closing_date: "Expected Closing Date",
    lead_source: "Lead Source",
    campaign_source: "Campaign Source",
    loss_reason: "Loss Reason",
    crm_lead_id: "CRM Lead ID",
    lead_owner: "Lead Owner",
    first_name: "First Name",
    last_name: "Last Name",
    designation: "Designation",
    lead_status: "Lead Status",
    purchase_order_id: "Purchase Order ID",
    purchase_order_number: "Purchase Order Number",
    vendor_name: "Vendor Name",
    po_date: "PO Date",
    expected_delivery_date: "Expected Delivery Date",
    total: "Total",
    grand_total: "Grand Total",
    sub_total: "Sub Total",
    tax: "Tax",
    discount: "Discount",
    round_off_amount: "Round Off Amount",
    adjustment: "Adjustment",
    sales_order_id: "Sales Order ID",
    sales_order_number: "Sales Order Number",
    billing_street: "Billing Street",
    shipping_street: "Shipping Street",
    number_of_employees: "Number Of Employees",
    chatAi: "Chat AI",
    rakoonChat: "Rakoon Chat",
    chatWithRakoonAi: "Chat With Rakoon AI",
    failure_reason: "Failure Reason",
    rakoon: "Rakoon",
    typeYourMessageHere: "Type your message here...",
    api: "API",
    userHistory: "User History",
    viewApiLog: "View API Log",
    statistics: "Statistics",
    syncManually: "Sync Manually",
    users: "Users",
    select: "Select",
    inputFieldChangedMessage: "You have unsaved changes. Do you want to continue?",
    continue: "Continue",
    syncStarted: "Synchronization Started",
    syncInitiated: "The synchronization process has been initiated successfully.",
    syncFailed: "Failed to initiate synchronization. Please try again.",
    syncCompleted: "Synchronization Completed",
    syncFinished: "Synchronization Finished",
    syncDateTime: "Sync DateTime",
    monday_id: 'Monday Id',
    newChat: "New Chat",
    deleteChatConfirmMessage: "Are you sure you want to delete?",
    showUser: "show User",
    Back: "Back",
    RakoonChat: "Rakoon Chat",
    gender: "Gender",
    birth_date: "Birth Date",
    employee_id: "Employee Id",
    Employees: "Employees",
    business_partner: "Business Partner",
    business_partner_uuid: 'UUID',
    created_by_user: 'Created By User',
    search_term1: 'search Term1',
    created_by: 'Created By',
    account_id: 'Account ID',
    campaign_type: 'Campaign Type',
    start_date: 'Start Date',
    entity_last_changed_on: 'Last Changed On',
    campaign: 'Campaigns',
    customers: 'Customers',
    customer_id: 'Customer Id',
    changed_by: 'Changed Id',
    postal_address: 'Postal Address',
    time_zone: 'TimeZone',
    partners: 'Partners',
    partner_id: 'Partner Id',
    promotions: 'Promotions',
    objective_text: 'Objective Text',
    promotion_type: 'Promotion Type',
    employee_responsible: 'Employee Responsible',
    products: 'Products',
    product_category_id: 'Product Category Id',
    base_uom: 'Base UOM',
    businessusers: "Business Users",
    object_id: "Object ID",
    etag: "ETag",
    employee_uuid: "Employee UUID",
    technical_user_id: "Technical User ID",
    identity_uuid: "Identity UUID",
    business_partner_name: "Business Partner Name",
    department_name: "Department Name",
    company_name: "Company Name",
    manager_name: "Manager Name",
    email_uri: "Email URI",
    decimal_format_code: "Decimal Format Code",
    decimal_format_code_text: "Decimal Format Code Text",
    date_format_code: "Date Format Code",
    date_format_code_text: "Date Format Code Text",
    time_format_code: "Time Format Code",
    time_format_code_text: "Time Format Code Text",
    time_zone_code: "Time Zone Code",
    time_zone_code_text: "Time Zone Code Text",
    logon_language_code: "Logon Language Code",
    logon_language_code_text: "Logon Language Code Text",
    user_validity_start_date: "User Validity Start Date",
    user_validity_end_date: "User Validity End Date",
    user_locked_indicator: "User Locked Indicator",
    user_counted_indicator: "User Counted Indicator",
    password_policy_code: "Password Policy Code",
    password_inactive_indicator: "Password Inactive Indicator",
    password_locked_indicator: "Password Locked Indicator",
    user_account_type_code: "User Account Type Code",
    user_account_type_code_text: "User Account Type Code Text",
    created_on: "Created On",
    user_created_by: "User Created By",
    user_changed_by: "User Changed By",
    contects: "Contacts",
    api_key: "API Key",
    base_url: "Base URL",
    aiThinking: "RakoonAI is thinking...",
    aiSearching: "RakoonAI is searching...",
    aiCompiling: "RakoonAI is compiling...",
    aiGenerating: "RakoonAI is generating...",
    aiFinalizing: "RakoonAI is finalizing...",
    rakoonaiFindingSources: "RakoonAI is finding the relevant data sources for your question.",
    rakoonaiCompilingAnswer: "RakoonAI is compiling an answer for you.",
    rakoonaiAnalyzingResults: "RakoonAI is analyzing the results.",
    rakoonaiComposingAnswer: "RakoonAI is composing your answer.",
    rakoonaiFinalizing: "Finalizing your answer.",
    rakoonaiSearchingIn: "Searching in",
    rakoonaiFoundIn: "Found results in",
    rakoonaiFoundSources: "Selected sources",
    searchingIn: "Searching in",
    foundResultsIn: "Found results in",
    noResultsFoundIn: "No results found in",
    automaticRoutingFailed: "Automatic routing did not return any indexes to search",
    errorInStoreMethod: "Error in store method",
    hideSuggestedQuestions: "Hide Suggested Questions",
    showSuggestedQuestions: "Show Suggested Questions",
    aiIndex: "AI Index",
    automatic: "Automatic",
    rakoonSap: "SAP Data",
    rakoonSalesforceMonday: "Salesforce & Monday.com",
    rakoonOfficeGsuite: "Office 365 & G-Suite",
    rakoonNotion: "Notion Workspace",
    searchQuestions: "Search questions...",
    index: "Index",
    userOrganization: "User Organization",
    emailCommunication: "Email Communication",
    securityCompliance: "Security & Compliance",
    dataAnalysis: "Data Analysis",
};

export default {
    locale: "en-US",
    messages: {
        title: titles
    },
};
